$(document).ready(function() {
  $('.rotate').click(function() {
    var $icon = $(this).find('.icon-rotate');
    var toOpenIcon = 'icon-plus-circle-o';
    var toCloseIcon = 'icon-minus-circle-o';
    var $collapsable = $(this).find('.collapse');
    $collapsable.collapse('toggle');
    $icon.toggleClass('opened');
    $icon.toggleClass(toCloseIcon);
    $icon.toggleClass(toOpenIcon);
  });

  $('.btn[data-load-on-click]').on('click', function() {
    $(this).addClass('btn-spinner disabled');
  });

  var hasWhitelist =
    $.fn.tooltip &&
    $.fn.tooltip.Constructor &&
    $.fn.tooltip.Constructor.DEFAULTS &&
    $.fn.tooltip.Constructor.DEFAULTS.whiteList['*'];

  if (hasWhitelist) {
    $.fn.tooltip.Constructor.DEFAULTS.whiteList['*'].push(/^data-[\w-]+$/i);
  }
});
